import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=1ca14250&scoped=true"
import script from "./customerService.vue?vue&type=script&lang=js"
export * from "./customerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca14250",
  null
  
)

export default component.exports